import React from 'react';
import { Navigate } from 'react-router-dom';
import { RouteConfig } from './types';

import AcademyLogin from '@/pages/academy/auth/login';
import AcademySignUp from '@/pages/academy/auth/sign_up';
import AcademyFindId from '@/pages/academy/auth/find_id';
import AcademyFindPassword from '@/pages/academy/auth/find_password';
import AcademyHome from '@/pages/academy/home';
import AcademyStudentList from '@/pages/academy/student/list';
import AcademyStudentDetail from '@/pages/academy/student/detail';
import AcademyStudentScheduleDetail from '@/pages/academy/student/scheduleDetail';
import AcademyExamResultDetail from '@/pages/academy/exam/result';
import AcademyTeacherList from '@/pages/academy/teacher/list';
import AcademyTeacherDetail from '@/pages/academy/teacher/detail';
import AcademyPaperList from '@/pages/academy/paper/list';
import AcademyPaperDetail from '@/pages/academy/paper/detail';
import AcademyPaperPayment from '@/pages/academy/paper/payment';
import AcademyPaperPaymentSuccess from '@/pages/academy/paper/paymentSuccess';
import AcademyPaperPaymentFail from '@/pages/academy/paper/paymentFail';
import AcademyMyPageInfo from '@/pages/academy/mypage/info';
import AcademyMypagePlan from '@/pages/academy/mypage/plan';
import AcademyMypagePaperList from '@/pages/academy/mypage/paper/list';
import AcademyMypagePaperDetail from '@/pages/academy/mypage/paper/detail';
import AcademyMypagePaymentHistory from '@/pages/academy/mypage/paymentHistory';
import AcademyMypageClassList from '@/pages/academy/mypage/calss';
import AcademyWordList from '@/pages/academy/word/list';
import AcademyWordDetail from '@/pages/academy/word/detail';
import AcademyWordbookList from '@/pages/academy/word/word_book/list';
import AcademyWordbookDetail from '@/pages/academy/word/word_book/detail';
import AcademyWordExamList from '@/pages/academy/word/word_exam/list';
import AcademyWordExamDetail from '@/pages/academy/word/word_exam/detail';
import AcademyStudentTrophyBadgeList from '@/pages/academy/student/trophy_badge/list';
import AcademyStudentTrophyBadgeDetail from '@/pages/academy/student/trophy_badge/detail';
import AcademyLearningGradingList from '@/pages/academy/learning/grading/list';
import AcademyLearningGradingDetail from '@/pages/academy/learning/grading/detail';
import AcademyLearningAssignList from '@/pages/academy/learning/assign/list';
import AcademyLearningAssignDetail from '@/pages/academy/learning/assign/detail';
import AcademyLearningDetail from '@/pages/academy/learning/detail';
import AcademyTextbookList from '@/pages/academy/textbook/list';
import AcademyTextbookDetail from '@/pages/academy/textbook/detail';
import AcademyTextbookPreview from '@/pages/academy/textbook/preview';

export const academyRoutes: RouteConfig[] = [
  {
    path: '/academy',
    name: '학원 인덱스 ✅',
    element: (
      <Navigate
        to={localStorage.getItem('academy_token') ? '/academy/home' : '/academy/login'}
        replace
      />
    ),
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/login',
    name: '학원 로그인 ✅', 
    element: <AcademyLogin />,
    background: 'solid',
    containerProps: { size: 'sm' },
  },
  {
    path: '/academy/sign_up',
    name: '학원 회원가입 ✅', 
    element: <AcademySignUp />,
    background: 'solid',
    containerProps: { size: 'sm' },
  },
  {
    path: '/academy/find_id',
    name: '학원 아이디 찾기 ✅', 
    element: <AcademyFindId />,
    background: 'solid',
    containerProps: { size: 'sm' },
  },
  {
    path: '/academy/find_password',
    name: '학원 비밀번호 찾기 ✅', 
    element: <AcademyFindPassword />,
    background: 'solid',
    containerProps: { size: 'sm' },
  },
  {
    path: '/academy/home',
    name: '학원 홈 ✅', 
    element: <AcademyHome />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/student/list',
    name: '학생 리스트 ✅', 
    element: <AcademyStudentList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/student/detail/:studentId',
    name: '학생 상세 ✅', 
    element: <AcademyStudentDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/student/schedule/:scheduleId',
    name: '학생 학습/숙제 상세(읽기전용) ✅',
    element: <AcademyStudentScheduleDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/exam/result/:examResultId',
    name: '학생 유료 시험 성적표 ✅',
    element: <AcademyExamResultDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/teacher/list',
    name: '강사 리스트 ✅', 
    element: <AcademyTeacherList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/teacher/detail/:teacherId',
    name: '강사 상세 ✅', 
    element: <AcademyTeacherDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/paper/list',
    name: '유료 시험 관리 ✅', 
    element: <AcademyPaperList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/paper/detail/:paperId',
    name: '유료 시험 상세 ✅', 
    element: <AcademyPaperDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/paper/payment',
    name: '시험지 결제 💳', 
    element: <AcademyPaperPayment />,
    background: 'solid',
    containerProps: { size: 'md' },
  },
  {
    path: '/academy/paper/payment/success',
    name: '결제 성공 ✅', 
    element: <AcademyPaperPaymentSuccess />,
    background: 'solid',
    containerProps: { size: 'md' },
  },
  {
    path: '/academy/paper/payment/fail',
    name: '결제 실패 ❌', 
    element: <AcademyPaperPaymentFail />,
    background: 'solid',
    containerProps: { size: 'md' },
  },  
  {
    path: '/academy/mypage/info',
    name: '마이페이지 기본정보 ✅', 
    element: <AcademyMyPageInfo />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/mypage/plan',
    name: '마이페이지 요금제 관리 ✅', 
    element: <AcademyMypagePlan />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/mypage/paper',
    name: '마이페이지 시험지 관리 ✅', 
    element: <AcademyMypagePaperList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/mypage/paper/detail/:paperId',
    name: '마이페이지 시험지 상세 ✅', 
    element: <AcademyMypagePaperDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/mypage/class',
    name: '마이페이지 클래스 관리 ✅', 
    element: <AcademyMypageClassList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/mypage/paymentHistory',
    name: '마이페이지 결제이력 ✅', 
    element: <AcademyMypagePaymentHistory />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/list',
    name: '단어 리스트 ✅', 
    element: <AcademyWordList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/detail',
    name: '단어 등록 ✅',
    element: <AcademyWordDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/detail/:wordId',
    name: '단어 상세 ✅', 
    element: <AcademyWordDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/word_book/list',
    name: '단어장 리스트 ✅', 
    element: <AcademyWordbookList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/word_book/detail',
    name: '단어장 등록 ✅', 
    element: <AcademyWordbookDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/word_book/detail/:wordbookId',
    name: '단어장 상세 ✅', 
    element: <AcademyWordbookDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/word_exam/list',
    name: '단어시험 리스트 ✅', 
    element: <AcademyWordExamList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/word_exam/detail',
    name: '단어시험 등록 ✅', 
    element: <AcademyWordExamDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/word/word_exam/detail/:wordExamId',
    name: '단어시험 상세 ✅', 
    element: <AcademyWordExamDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/student/trophy_badge/list',
    name: '트로피 및 뱃지 리스트 ✅', 
    element: <AcademyStudentTrophyBadgeList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/student/trophy_badge/detail/:awardId',
    name: '트로피 및 뱃지 상세 ✅', 
    element: <AcademyStudentTrophyBadgeDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/textbook/list',
    name: '교재 리스트 ✅',
    element: <AcademyTextbookList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/textbook/:textbookId',
    name: '교재 상세 ✅',
    element: <AcademyTextbookDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/textbook/:textbookId/unit/:unitId/preview',
    name: '교재 유닛 미리보기 ✅',
    element: <AcademyTextbookPreview />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/learning/grading/list',
    name: '숙제 채점 리스트 ✅', 
    element: <AcademyLearningGradingList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/learning/grading/detail',
    name: '숙제 채점 상세 ✅', 
    element: <AcademyLearningGradingDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/learning/assign/list',
    name: '학습 배분 리스트 ✅', 
    element: <AcademyLearningAssignList />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/learning/assign/detail',
    name: '학습 배분 상세 ✅', 
    element: <AcademyLearningAssignDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/academy/learning/detail/:eventId',
    name: '학습 상세 ✅', 
    element: <AcademyLearningDetail />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
];

